export default __webpack_public_path__ + "static/media/communication.83fa5a5b.svg";